/* eslint-disable */
import Vue from 'vue';
import store from '../store/store';
import miniToastr from 'mini-toastr';
import VueSocketIO from 'vue-socket.io';
import router from './../router';
import config from 'config/config.js';
import Persister from './../utils/LocalStoragePersister';
import UserService from "../services/UserService";
import MinibusRequestService from "../services/MinibusRequestService";
import MinibusService from "../services/MinibusService";
import ContractRequestService from "../services/ContractRequestService";
import RegieRequestService from "../services/RegieRequestService";
import RetourRegieRequestService from "../services/RetourRegieRequestService";
import StructureService from "../services/StructureService";
import DailyReportService from "../services/DailyReportService";
import NotificationService from "../services/NotificationService";
import TaskService from "../services/TaskService";
import MedicalLeaveService from "../services/MedicalLeaveService";
import EmployeeService from "../services/EmployeeService";
import confirmModal from "./confirmModal";
import io from 'socket.io-client';
import AbsenceRequestService from "../services/AbsenceRequestService";

export default (store) => {
  // miniToastr Configuration
  miniToastr.init();
  miniToastr.setIcon('error', 'i', {
    'class': 'fa fa-times'
  });
  miniToastr.setIcon('warn', 'i', {
    'class': 'fa fa-exclamation-triangle'
  });
  miniToastr.setIcon('info', 'i', {
    'class': 'fa fa-info-circle'
  });
  miniToastr.setIcon('success', 'i', {
    'class': 'fa fa-check-circle'
  });
  Vue.prototype.$miniToastr = miniToastr;

  // Socket IO for notifications
  let options = {};
  if (config.socket.options) {
    options = { path: config.socket.options }
  }
  Vue.use(new VueSocketIO({
    debug: true,
    connection: io(config.socket.url, options),
    vuex: {
      store,
      actionPrefix: "socket_"
    }
  }));

  // Axios Configuration
  const token = Persister.get('user_token');
  window.axios = require('axios');
  window.axios.defaults.baseURL = config.api.url;
  if (token) {
    window.axios.defaults.headers.common = {
      'Authorization': 'Bearer ' + token
    };
  }

  // Interceptors Axios
  // TODO: Better handling error messages with translation
  axios.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    if (error.response && error.response.data && error.response.data.message) {
       miniToastr.error(error.response.data.message, "Error")
    }
    if (error.response && error.response.status === 401) {
      if (router.currentRoute.name !== 'login') {
        router.push('/login');
      }
    }
    return Promise.reject(error);
  });

  // Services injections in Vue
  const services = {
    user: new UserService(window.axios),
    structure: new StructureService(window.axios),
    notification: new NotificationService(window.axios),
    absenceRequest: new AbsenceRequestService(window.axios),
    dailyReport: new DailyReportService(window.axios),
    task: new TaskService(window.axios),
    medicalLeave: new MedicalLeaveService(window.axios),
    minibusRequest: new MinibusRequestService(window.axios),
    minibusManagement: new MinibusService(window.axios),
    contractRequestService: new ContractRequestService(window.axios),
    regieRequestService: new RegieRequestService(window.axios),
    retourRegieRequestService: new RetourRegieRequestService(window.axios),
    employeeService: new EmployeeService(window.axios),
  };

  Vue.prototype.$services = services;
  store.$services = services;

  // injection confirm modal
  Vue.use(confirmModal);
}

